import { Component } from '@angular/core';

@Component({
    selector: 'app-page-404',
    templateUrl: './page-404.component.html',
    styleUrls: ['./page-404.component.scss'],
    standalone: true,
})
export class Page404Component {
    constructor() {}

    goBack() {
        window.history.back();
    }
}
